import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import Article from "@/pages/article/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Navigate to="/en/" replace />,
  },
  {
    path: "/:lang/",
    element: <Home />,
  },
  {
    path: "/:lang/article/:slug",
    element: <Article />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;